import { Scope, useProps } from "@/lib/page-rendering"

import {
  SearchEducatorsShowTeacherCapabilities,
  SearchEducatorsShowTeamCapabilities,
  SearchEducatorsTeachersTeacherDocument,
  SearchEducatorsTeamsTeamDocument,
  SearchShortlistMembership,
} from "@/types/serializers"

export type ShowTeacherProps = {
  teacher: SearchEducatorsTeachersTeacherDocument
  teacher_profile_uuid: string
  relief_invitable_token: string | null
  shortlists: SearchShortlistMembership[]
  capabilities: SearchEducatorsShowTeacherCapabilities
}

export type ShowTeamProps = {
  team: SearchEducatorsTeamsTeamDocument
  team_profile_uuid: string
  relief_invitable_token: string | null
  shortlists: SearchShortlistMembership[]
  capabilities: SearchEducatorsShowTeamCapabilities
}

// The add sheet accepts only its add page. A rejected submission re-renders
// it in the sheet with its errors; a successful one resolves to a show page,
// which the sheet hands to the page beneath and closes.
export const addEducatorToShortlist: Scope = (resolved) =>
  resolved.name === "search/educators/shortlist_entries/new"

export const useShowTeacherProps = () => useProps<ShowTeacherProps>()

export const useShowTeamProps = () => useProps<ShowTeamProps>()
